import './App.css';
import Main from './Components/Main';
import Work from './Components/Work';
import { BrowserRouter,Routes ,Route } from 'react-router-dom'
import Projects from './Pages/Projects';
import ContactForm from './Pages/ContactForm';
import ScrollToTop from './Extra/ScrollTop';
import Myself from './Pages/Myself';

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop/>
    <Routes>
      <Route path='/' element={<Main/>}/>
      <Route path='/about-me' element={<Myself/>}/>
      <Route path='/projects' element={<Projects/>}/>
      <Route path='/contact' element={<ContactForm/>}/>
      <Route path='/work' element={<Work/>}/>
    </Routes>
    </BrowserRouter>
  );
}

export default App;